import React, { useEffect, useState } from 'react';
import SocialMediaLinks from './SocialMediaLinks';
import { getData } from '../helpers/ApiSettings';

const Footer = () => {
  const [companyInfo, setCompanyInfo] = useState(null);
  const [bottomNav, setBottomNav] = useState([]);
  const [legalNav, setLegalNav] = useState([]);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const respInfo = await getData('/company-info?populate=*');
        const respBotNav = await getData('/bottom-navigation');
        const respLegNav = await getData('/legal-navigation');
        // console.log(respBotNav.data.data.menuItems)
        setCompanyInfo(respInfo.data.data);
        setBottomNav(respBotNav.data.data.menuItems);
        setLegalNav(respLegNav.data.data.menuItems);
      } catch (error) {
        console.error('Error fetching company info:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <footer className="footer bg-dark text-light">
      <div className="container">
        <div className="row">
          {/* Column 1: Logo and small description */}
          <div className="col-md-4">
            {/* <img src="/path-to-logo.png" alt="OVLM Logo" className="mb-3" style={{ width: '150px' }} /> */}
            <h4 className='ovlm-gradient-text'>OVLM</h4>
            <p>Voyagez léger avec vos enfants en Guadeloupe. Location de matériel de puériculture pour des vacances sans soucis.</p>
          </div>
          
          {/* Column 2: Quick Links */}
          <div className="col-md-4">
            <h5>Liens rapides</h5>
            <ul className="list-unstyled">
              {bottomNav.map((item, index) => (
                <li key={index}>
                  <a href={item.link} className="text-light">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Column 3: Legal Links */}
          <div className="col-md-4">
            <h5>Informations légales</h5>
            <ul className="list-unstyled">
              {legalNav.map((item, index) => (
                <li key={index}>
                  <a href={item.link} className="text-light">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Social Media Icons */}
        <div className="row mt-5">
          <SocialMediaLinks socialMedia={companyInfo?.socialmedia || []} mode="dark" />
          {/* <div className="col text-center">
            <a href="#" className="text-light mx-2"><i className="fa-brands fa-facebook"></i></a>
            <a href="#" className="text-light mx-2"><i className="fa-brands fa-instagram"></i></a>
          </div> */}
        </div>
        
        {/* Footer Bottom: Copyright and Design */}
        <div className="row mt-5">
          <div className="col-md-6 text-md-start text-sm-center">
            <p>&copy; {currentYear} OVLM. Tous droits réservés.</p>
          </div>
          <div className="col-md-6 text-md-end text-sm-center">
            <p><a href="https://karib-tech.com" target="_blank">Design by Karib Tech</a></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
